import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { useSelector } from 'react-redux';

import OlMap from '@/helpers/OlMap';

const Dock = ({ data: robot }) => {
  const dockOsdStatus = useSelector((state) => state.telemetry[robot.id]?.dockOsdStatus);

  useMountEffect(() => {
    return () => {
      OlMap.removeDockMarker(robot.id);
    };
  });

  useUpdateEffect(() => {
    const { latitude: lat, longitude: lng } = dockOsdStatus;

    OlMap.addDockMarker(robot.id, { lat, lng }, robot.color);
  }, [dockOsdStatus]);
};

export default Dock;
